
import shelby from './banner2.png';
import alice from './alice-smith.png';

import './Banner.css';

const Banner = () => {
    return(
        <div className="Banner" style={{backgroundImage: `url(${shelby})`}}>
            <div className="name-container">
                <div className="oranienbaum name">
                    ALICE E. SMITH
                </div>
                <div className="abel">
                    Joe W. Forehand, Jr. Distinguished Professor<br />
                    Department of Industrial and Systems Engineering
                </div>
                <hr />
                <div className="abel">
                    3301P Shelby Center<br />
                    Auburn, AL 36849, USA<br />
                    smithae@auburn.edu
                </div>
            </div>
            <div className="face-container">
                <img alt="Alice E. Smith" className="face" src={alice} />
            </div>
        </div>
    )
};

export default Banner;